var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 7.50033H13.3334C14.2175 7.50033 15.0653 7.85151 15.6904 8.47664C16.3156 9.10176 16.6667 9.9496 16.6667 10.8337C16.6667 11.7177 16.3156 12.5656 15.6904 13.1907C15.0653 13.8158 14.2175 14.167 13.3334 14.167H12.5001M7.50008 10.8337L4.16675 7.50033L7.50008 4.16699V10.8337Z",
    stroke: "#A5A5A6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackList);
export default __webpack_public_path__ + "static/media/arrow-back-list.f4207f71806356a900edbff7ff9fd3f6.svg";
export { ForwardRef as ReactComponent };